// @flow
import { connect } from 'react-redux';

import ModalFormCentenaireDownload from 'components/centenaire/ModalFormCentenaireDownload';

import type { DispatchType, StateType } from 'types/Actions';
import type { StateProps, DispatchProps } from 'components/centenaire/ModalFormCentenaireDownload';

import { displayModal } from 'actions/modalActions';

export default connect(
  (state: StateType): StateProps => ({}),
  (dispatch: DispatchType): DispatchProps => ({
    displayModal: (modalObject: string, content: Object) => dispatch(displayModal(modalObject, content))
  })
)(ModalFormCentenaireDownload);
